export function extractErrorMessage(error: string | object | undefined): string | undefined {
  if (typeof error === 'string') {
    return error
  }

  if (typeof error !== 'object' || error === null) {
    return undefined
  }

  // @ts-ignore
  if (typeof error.message === 'string') {
    // @ts-ignore
    return error.message
  }

  const toStringResult = error.toString()

  if (!toStringResult.startsWith('[object ')) {
    return toStringResult
  }

  return undefined
}
